import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const ganttApi = {
  getTimeline: (projectKey) =>
    api.get(`/projects/${projectKey}/gantt`).then(unwrap),

  bulkUpdate: (projectKey, updates) =>
    api.put(`/projects/${projectKey}/gantt/bulk`, { updates }).then(unwrap),

  listDependencies: (projectKey) =>
    api.get(`/projects/${projectKey}/gantt/dependencies`).then(unwrap),

  createDependency: (projectKey, payload) =>
    api.post(`/projects/${projectKey}/gantt/dependencies`, payload).then(unwrap),

  deleteDependency: (projectKey, depId) =>
    api.delete(`/projects/${projectKey}/gantt/dependencies/${depId}`).then(unwrap),

  criticalPath: (projectKey) =>
    api.get(`/projects/${projectKey}/gantt/critical-path`).then(unwrap),

  listBaselines: (projectKey) =>
    api.get(`/projects/${projectKey}/gantt/baselines`).then(unwrap),

  getBaseline: (projectKey, id) =>
    api.get(`/projects/${projectKey}/gantt/baselines/${id}`).then(unwrap),

  createBaseline: (projectKey, name) =>
    api.post(`/projects/${projectKey}/gantt/baselines`, { name }).then(unwrap),

  deleteBaseline: (projectKey, id) =>
    api.delete(`/projects/${projectKey}/gantt/baselines/${id}`).then(unwrap),

  updateSettings: (projectKey, patch) =>
    api.put(`/projects/${projectKey}/gantt/settings`, patch).then(unwrap),

  exportUrl: (projectKey, format = 'csv') =>
    `/projects/${projectKey}/gantt/export?format=${encodeURIComponent(format)}`,
};
